import http from "../../../../../../../core/utils/apis/skillApi";

const BASE = "/evaluation-forms";

export const EvaluationFormService = {
  getAll: () => http.get(BASE).then((res) => res.data),

  getById: (id) => http.get(`${BASE}/${id}`).then((res) => res.data),

  getByYear: (year) => http.get(`${BASE}/year/${year}`).then((res) => res.data),

  create: (data) => http.post(BASE, data).then((res) => res.data),

  update: (id, data) =>
    http.patch(`${BASE}/${id}`, data).then((res) => res.data),

  remove: (id) => http.delete(`${BASE}/${id}`).then((res) => res.data),

  getAllSubmissions: (formId) =>
    http.get(`/evaluation-submissions/form/${formId}`).then((res) => res.data),
  searchUsersByName: (query) => http.get(`/users/search/${query}`),
  
};
